// ══════════════════════════════════════════════════════════════════════════
// WHOSE WAITING WORK IS ON THIS SCREEN, AND WHICH PILE OWNS A RECEIPT
// (ZEN-687)
// ══════════════════════════════════════════════════════════════════════════
//
// ★ WHY THIS IS A FILE OF ITS OWN. The orange number beside a menu item and
// the page behind it were worked out in two different places from two
// different rules. On 2026-09-22 the menu said four approvals were waiting and
// the page said there were none. The server now answers both questions from
// one rule (backend/helpers.py — owner_work_scope, receipts_waiting_for_review,
// receipts_set_aside, receipts_awaiting_owner_approval). These are the screen's
// half of exactly the same two rules, kept together and named, so the next
// person changing one can see there is a second copy to keep in step.
//
// THE TWO RULES:
//   1. A receipt carrying a submission marker is part of a beneficiary's
//      submit-and-approve story. It belongs to Approvals and to nothing else.
//   2. What is on screen is whatever the beneficiary dropdown says — and when
//      it says "All beneficiaries", that means the active ones plus work
//      nobody has put a name to yet.

// RULE 1. Sending a receipt for approval writes `submission_status` and leaves
// `status` reading "pending", so a submitted receipt used to sit in the import
// queue as well as the approval queue — listed twice, counted twice, with each
// screen offering a different action on it. Rejecting from the import queue is
// the door that records no reason, which a beneficiary is owed (ZEN-608), so
// this rule closes that door rather than patching it.
//
// A receipt the account owner uploaded herself has NO marker at all
// (backend/routes/receipts.py writes None for an owner), which is what makes
// this the right question to ask: anything with a marker came in through a
// beneficiary, whatever the marker happens to say.
export const inSubmissionFlow = (receipt) => !!(receipt && receipt.submission_status);

// RULE 2. The same split the server makes in helpers.owner_work_scope.
//
// UNASSIGNED WORK ALWAYS COUNTS IN THE "ALL BENEFICIARIES" VIEW, and that is
// load-bearing: a receipt nobody has put a name to is exactly the kind that
// gets forgotten. "Leave out the archived" must never quietly become "leave
// out the ones with no name on them yet".
//
// AN ARCHIVED BENEFICIARY YOU HAVE DELIBERATELY PICKED still shows their work.
// The dropdown offers archived people under their own heading on purpose; what
// was wrong was their unfinished work adding to the household number for ever,
// where nobody could clear it.
export const forTheSelectedBeneficiary = (rows, selectedStudentId, archivedIds) => {
  if (selectedStudentId) return rows.filter((r) => r.student_id === selectedStudentId);
  const archived = new Set(archivedIds || []);
  return rows.filter((r) => !r.student_id || !archived.has(r.student_id));
};

// The archived identifiers, read off the beneficiary list the screens already
// hold, so no screen has to remember the shape of that field.
export const archivedBeneficiaryIds = (students) =>
  (students || []).filter((s) => s && s.archived).map((s) => s.id);
